// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const firebaseConfigLawyer = {
  apiKey: process.env.REACT_APP_FB_LAWYER_API_KEY,
  authDomain: process.env.REACT_APP_FB_LAWYER_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_LAWYER_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_LAWYER_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_LAWYER_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_LAWYER_APPID,
  measurementId: process.env.REACT_APP_FB_LAWYER_MEASUREMENTID
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const lawyerApp = firebase.initializeApp(firebaseConfigLawyer, 'firebaseLawyer');

const analytics = getAnalytics(app);
export const firebaseInstance = firebase;
export const authService = firebase.auth();
export const dbService = firebase.firestore();
export const storageService = firebase.storage();
export const lawyerStorageService = lawyerApp.storage("gs://justitia-lawyer.appspot.com");